export let memberCountSingular = "kdFyBd";
export default {memberCountSingular};